exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-content.orders-report {\n  max-width: 100%;\n}\n", ""]);

// exports
